// roles.js

export const ROLES = {
    ADMIN: "admin",
    TEAM_LEAD: "team lead",
    USER: "user",
  };
  
  export const DEPARTMENTS = {
    EXECUTIVE: "executive",
    FINANCE: "finance",
    HR: "hr",
    TECH: "tech",
    SALES: "sales",
  };
  
  // A numeric hierarchy: higher numbers mean higher privileges.
  // For instance, admin can see everything, team leads have intermediate privileges,
  // and regular users have the lowest.
  export const ROLE_HIERARCHY = {
    [ROLES.ADMIN]: 2,
    [ROLES.TEAM_LEAD]: 1,
    [ROLES.USER]: 0,
  };
  